export default __webpack_public_path__ + "static/media/keycdn.e71ea5c1.svg";